module.exports = __webpack_public_path__ + "img/ic_12_ranking_down.dd064bbe.svg";